import * as Yup from 'yup';

export const schema = Yup.object().shape({
  visibility: Yup.number()
    .required('Required')
    .min(0, 'Minimum value is 0')
    .max(10000, 'Maximum value is 10000 meters'),
});
